/* eslint-disable react-refresh/only-export-components -- badgeVariants is part of the public API */
import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex max-w-full items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold tracking-[0.02em] transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 [&>svg]:h-3 [&>svg]:w-3 [&>svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-white',
        secondary: 'border-transparent bg-secondary-strong text-white',
        success: 'border-transparent bg-success text-white',
        // Amber carries ink navy, not white: 7.93:1 against the fill, and the
        // same pairing the sidebar uses for the active item.
        warning: 'border-transparent bg-warning text-primary',
        error: 'border-transparent bg-error text-white',
        outline: 'text-gray-900 border-gray-300',
        active: 'border-transparent bg-success text-white',
        inactive: 'border-transparent bg-muted-foreground text-white',
        pending: 'border-transparent bg-warning text-primary',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, children, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props}>
      <span className="truncate">{children}</span>
    </div>
  );
}

export { Badge, badgeVariants };
